// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**** All tooltips go here. Including confirmation tooltips ****/

/* The confirmation tooltip used in TA/premiumAdmin section */
.confirmSave {
  position: absolute;
  background-color: white;
  top: 15rem;
  height: 14rem;
  width: 20rem;
  z-index: 2;
  display: flex;
  flex-direction: column;
  padding-top: 2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 1rem;
  -webkit-box-shadow: 0px 0px 31px 0px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: 0px 0px 31px 0px rgba(0, 0, 0, 0.32);
  box-shadow: 0px 0px 31px 0px rgba(0, 0, 0, 0.32);
}

.confirmWaive {
  height: 19rem !important;
}

.confirmReactivate {
  height: 16rem !important;
}

/* Confirm save content */
.confirmSave .options {
  margin-top: 2rem;
}

.confirmSave .option a,
.confirmSave .option input.confirmSaveYes {
  color: gray;
  background: none;
  border: none;
  text-decoration: underline;
  font-size: 16px;
  padding: 0px;
}

.confirmSave .options .option + .option:before {
  /* Pipe bars between course meta items*/
  content: '|';
  color: black;
  padding-right: 6px;
  margin-left: 1.5rem;
  margin-right: 0.9rem;
}

.confirmSave .message {
  text-align: center;
}

.confirmSave .options {
  display: flex;
  justify-content: center;
}

/* Arrow at top of tooltip */
.confirmSave:after,
.arrow_box:before {
  bottom: 100%;
  left: 50%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.confirmSave:after {
  border-color: rgba(136, 183, 213, 0);
  border-bottom-color: white;
  border-width: 1rem;
  margin-left: calc(-10px);
}

.confirmSave:before {
  border-color: rgba(194, 225, 245, 0);
  border-bottom-color: #c2e1f5;
  border-width: 36px;
  margin-left: -36px;
}

.confirmCancel {
  margin-left: -50px;
}

.confirmSaveUser {
  margin-left: 250px;
  z-index: 3 !important;
}

.confirmAddUser {
  margin-left: 36px;
  z-index: 3 !important;
}

/* The loading-spinner has a 100px margin by default which
 * makes it appear outside of the tooltip. This fixes the spinner
 * in this specific case */
.confirmSave .spinner {
  margin: 34px auto;
}

.removeCourseContainer {
  position: relative;
}
.confirmRemove {
  position: absolute;
  top: auto;
  right: 1.5rem;
  width: 10rem;
}

.confirmMarkSuccessful {
  top: auto;
  width: 25rem;
  height: 5rem;
  margin: 1rem;
  margin-left: -10rem;
}

.confirmMarkSuccessful .options {
  margin-top: 0;
}

.confirmCloseSelectedUsers {
  top: 5rem;
  left: 68rem;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/tooltips.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,wDAAwD;EACxD,qDAAqD;EACrD,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;;EAEE,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;0BAE0B;AAC1B;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,WAAW;AACb","sourcesContent":["/**** All tooltips go here. Including confirmation tooltips ****/\n\n/* The confirmation tooltip used in TA/premiumAdmin section */\n.confirmSave {\n  position: absolute;\n  background-color: white;\n  top: 15rem;\n  height: 14rem;\n  width: 20rem;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  padding-top: 2rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-bottom: 1rem;\n  -webkit-box-shadow: 0px 0px 31px 0px rgba(0, 0, 0, 0.32);\n  -moz-box-shadow: 0px 0px 31px 0px rgba(0, 0, 0, 0.32);\n  box-shadow: 0px 0px 31px 0px rgba(0, 0, 0, 0.32);\n}\n\n.confirmWaive {\n  height: 19rem !important;\n}\n\n.confirmReactivate {\n  height: 16rem !important;\n}\n\n/* Confirm save content */\n.confirmSave .options {\n  margin-top: 2rem;\n}\n\n.confirmSave .option a,\n.confirmSave .option input.confirmSaveYes {\n  color: gray;\n  background: none;\n  border: none;\n  text-decoration: underline;\n  font-size: 16px;\n  padding: 0px;\n}\n\n.confirmSave .options .option + .option:before {\n  /* Pipe bars between course meta items*/\n  content: '|';\n  color: black;\n  padding-right: 6px;\n  margin-left: 1.5rem;\n  margin-right: 0.9rem;\n}\n\n.confirmSave .message {\n  text-align: center;\n}\n\n.confirmSave .options {\n  display: flex;\n  justify-content: center;\n}\n\n/* Arrow at top of tooltip */\n.confirmSave:after,\n.arrow_box:before {\n  bottom: 100%;\n  left: 50%;\n  border: solid transparent;\n  content: ' ';\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\n.confirmSave:after {\n  border-color: rgba(136, 183, 213, 0);\n  border-bottom-color: white;\n  border-width: 1rem;\n  margin-left: calc(-10px);\n}\n\n.confirmSave:before {\n  border-color: rgba(194, 225, 245, 0);\n  border-bottom-color: #c2e1f5;\n  border-width: 36px;\n  margin-left: -36px;\n}\n\n.confirmCancel {\n  margin-left: -50px;\n}\n\n.confirmSaveUser {\n  margin-left: 250px;\n  z-index: 3 !important;\n}\n\n.confirmAddUser {\n  margin-left: 36px;\n  z-index: 3 !important;\n}\n\n/* The loading-spinner has a 100px margin by default which\n * makes it appear outside of the tooltip. This fixes the spinner\n * in this specific case */\n.confirmSave .spinner {\n  margin: 34px auto;\n}\n\n.removeCourseContainer {\n  position: relative;\n}\n.confirmRemove {\n  position: absolute;\n  top: auto;\n  right: 1.5rem;\n  width: 10rem;\n}\n\n.confirmMarkSuccessful {\n  top: auto;\n  width: 25rem;\n  height: 5rem;\n  margin: 1rem;\n  margin-left: -10rem;\n}\n\n.confirmMarkSuccessful .options {\n  margin-top: 0;\n}\n\n.confirmCloseSelectedUsers {\n  top: 5rem;\n  left: 68rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
